import React, { Component } from 'react';
import { connect } from 'react-redux';
import { UserActions, CouponActions } from '../../actions'
import { RegularPage } from '../Templates';
import {FormControl, Grid, Button, Paper, Select, CircularProgress, colors, Typography, MenuItem} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
    grid: {
        padding: theme.spacing.unit * 3,
    },
    generateButton: {
        marginTop: '1vw'
    },
    couponCode: {
        padding: '1vw 2vw',
        marginTop: '1.5vw',
        background: colors.green[500],
        color: 'white',
        width: '100%',
        borderRadius: '5px',
        textAlign: 'center'
    },
    paper: {
        width: '30vw',
        padding: '2vw',
        flexDirection: 'column',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    generateTitle: {
        marginBottom: '2vw'
    },
    fabProgress: {
        color: colors.green[500]
    }
});

class CouponPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            userEmail: ""
        }

        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.generateCoupon = this.generateCoupon.bind(this);
    }

    componentDidMount() {
        const {dispatch} = this.props;
        dispatch(UserActions.getAllUsers());
    }

    handleSelectChange(e) {
        this.setState({userEmail: e.target.value});
    }

    generateCoupon() {
        const {dispatch} = this.props;
        dispatch(CouponActions.create({userEmail: this.state.userEmail}));
    }

    render () {
        const { classes, users, coupons } = this.props;

        let allUsers = null;
        if(users && users.list) {
            allUsers = users.list.map((item) => (
                <MenuItem key={item._id} value={item.email}>
                    {`${item.name} - ${item.email}`}
                </MenuItem>
            ));
        }

        let coupon = false;
        if(coupons && coupons.list && coupons.list.hasOwnProperty(this.state.userEmail)) {
            coupon = coupons.list[this.state.userEmail];
        }

        return (
            <RegularPage>
                <Grid 
                    className={classes.grid}
                    container
                >
                    <Paper className={classes.paper}>
                        <Typography variant="title" className={classes.generateTitle}>
                            Generate coupon code
                        </Typography>
                        <FormControl fullWidth>
                            <Select
                                value={this.state.userEmail}
                                onChange={this.handleSelectChange}
                                displayEmpty
                                inputProps={{
                                    name: 'User',
                                    id: 'select-user',
                                }}
                            >
                                <MenuItem value="">
                                    <em>Select user</em>
                                </MenuItem>
                                {allUsers}
                            </Select>
                        </FormControl>
                        <Button
                            className={classes.generateButton}
                            fullWidth
                            type="button"
                            variant="raised"
                            color="primary"
                            onClick={this.generateCoupon}
                            disabled={coupons.createCouponProcess}
                        >
                            {!coupons.createCouponProcess && `Generate`}
                            {coupons.createCouponProcess && <CircularProgress size={20} className={classes.fabProgress}/>}
                        </Button>
                        <Typography variant="headline" className={`${classes.couponCode} ${!coupon ? 'hide' : ''}`}>
                            Coupon code: <strong>{coupon}</strong>
                        </Typography>
                    </Paper>
                </Grid>
            </RegularPage>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        users: state.userReducer,
        coupons: state.couponReducer
    }
}

const CouponPageWithRedux = withStyles(styles)(connect(mapStateToProps)(CouponPage));

export {CouponPageWithRedux as CouponPage};


// WEBPACK FOOTER //
// ./src/components/CouponPage/CouponPage.jsx